<template lang="html">
  <cw-list-cell
    :title="title"
    :subtitle="subtitle"
    :disclosureDetail="`${(boxSetInfo.box && boxSetInfo.box.boxNumber) || ''}`"
    :leftIconProps="{
      badge: boxSizeString,
      scale: 'is-medium',
      colorClass: 'tag is-steel',
    }"
    class="has-border-bottom"
    @click="$emit('click')"
  >
  </cw-list-cell>
</template>

<script>
export default {
  name: 'cw-box-cell',
  // share common functionality with component mixins
  mixins: [],
  props: {
    boxSetInfo: {
      type: Object,
      required: true,
    },
    showProjectInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  // variables
  data() {
    return {};
  },
  computed: {
    boxSizeString() {
      // Duplicate in OrderCell.vue
      let setBoxSize =
        this.boxSetInfo && this.boxSetInfo.box && this.boxSetInfo.box.boxSize;
      let orderedBoxSize = this.boxSetInfo && this.boxSetInfo.boxSize;

      let displayedSize = setBoxSize || orderedBoxSize;

      return `${displayedSize} ${(displayedSize !== 'washout' && 'yd') || ''}`;
    },
    boxSizeIcon() {
      return {
        name: 'box',
        scale: 3,
        label: this.boxSizeString,
        colorClass: 'has-text-primary',
        overlayText: this.boxSizeString,
      };
    },
    title() {
      let info = this.boxSetInfo;
      if (!info) return '';
      // If there is a subProject, display it as a Lot number,
      // otherwise display the intendedUse,
      // as a last resort, display the boxNumber
      return (
        (info.subProject &&
          info.subProject.name &&
          `Lot ${info.subProject.name}`) ||
        info.intendedUse ||
        (info.box && info.box.boxNumber) ||
        ''
      );
    },
    subtitle() {
      let info = this.boxSetInfo;
      // If the intendedUse is not being used as the title, use if for the subtitle

      return (
        (info && this.showProjectInfo && info.project && info.project.name) ||
        (info &&
          info.intendedUse &&
          info.intendedUse !== this.title &&
          info.intendedUse) ||
        ''
      );
    },
  },
  components: {},
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="stylus" scoped></style>
